import React from 'react';
import { useLingui } from '@lingui/react/macro';

import {
  SearchParamsPetCounts,
  SearchParamsPetType,
} from '@rover/constants/src/translations/sitterProfilePage.constants';
import { emitAnalyticsEvent } from '@rover/rsdk/src/modules/Analytics';
import type { PriceTransparencyLevel } from '@rover/types/src/PriceTransparencyLevel';

import { useRevampProfileContext } from '../../hooks/useRevampProfileContext';
import AccordionSection from '../AccordionSection/AccordionSection';
import ServiceSection from '../ServiceSection/ServiceSection';

import { SitterProfileAllServiceExpandEvent } from './analyticsEvents';

type Props = {
  selectedPetType: SearchParamsPetType;
  petCounts: SearchParamsPetCounts;
  isRequoting?: boolean;
  priceTransparencyLevel?: PriceTransparencyLevel;
  isShowingPriceInCurrency?: boolean;
  bookingFeePercentage?: string;
};

const AllServicesSection = ({
  selectedPetType,
  petCounts,
  isRequoting,
  priceTransparencyLevel,
  isShowingPriceInCurrency,
  bookingFeePercentage,
}: Props): JSX.Element | null => {
  const { t } = useLingui();
  const [numberOfServices, setNumberOfServices] = React.useState(0);
  const { sitterData } = useRevampProfileContext();

  return (
    <AccordionSection
      sectionName="all-services"
      title={t`All Services (${numberOfServices})`}
      onExpand={() => emitAnalyticsEvent(new SitterProfileAllServiceExpandEvent())}
      body={
        <ServiceSection
          sitterProfile={sitterData}
          petType={selectedPetType}
          petCounts={petCounts}
          isRequoting={isRequoting}
          priceTransparencyLevel={priceTransparencyLevel}
          isShowingPriceInCurrency={isShowingPriceInCurrency}
          bookingFeePercentage={bookingFeePercentage}
          isRevampVersion
          setNumberOfServices={setNumberOfServices}
        />
      }
    />
  );
};

export default AllServicesSection;
